import {
	GET_EMAIL_API_SETTINGS_FAIL,
	GET_EMAIL_API_SETTINGS_REQ,
	GET_EMAIL_API_SETTINGS_SUCCESS,
	SAVE_HUNTER_SETTINGS_FAIL,
	SAVE_HUNTER_SETTINGS_REQ,
	SAVE_HUNTER_SETTINGS_SUCCESS,
	SAVE_TOMBA_SETTINGS_FAIL,
	SAVE_TOMBA_SETTINGS_REQ,
	SAVE_TOMBA_SETTINGS_SUCCESS,
	SAVE_ABSTRACT_SETTINGS_REQ,
	SAVE_ABSTRACT_SETTINGS_SUCCESS,
	SAVE_ABSTRACT_SETTINGS_FAIL
} from '../constants/settings';

export const emailApiReducer = (state = {}, action) => {
	switch (action.type) {
		case GET_EMAIL_API_SETTINGS_REQ:
			return { loading: true };
		case GET_EMAIL_API_SETTINGS_SUCCESS:
			return { loading: false, emailApis: action.payload };
		case GET_EMAIL_API_SETTINGS_FAIL:
			return { loading: false, error: action.payload };
		case SAVE_TOMBA_SETTINGS_REQ:
			return { ...state, loading: true };
		case SAVE_TOMBA_SETTINGS_SUCCESS:
			return { loading: false, emailApis: action.payload };
		case SAVE_TOMBA_SETTINGS_FAIL:
			return { loading: false, error: action.payload };
		case SAVE_HUNTER_SETTINGS_REQ:
			return { ...state, loading: true };
		case SAVE_HUNTER_SETTINGS_SUCCESS:
			return { loading: false, success: true, emailApis: action.payload };
		case SAVE_HUNTER_SETTINGS_FAIL:
			return { loading: false, error: action.payload };
		case SAVE_ABSTRACT_SETTINGS_REQ:
			return { ...state, loading: true };
		case SAVE_ABSTRACT_SETTINGS_SUCCESS:
			return { loading: false, success: true, emailApis: action.payload };
		case SAVE_ABSTRACT_SETTINGS_FAIL:
			return { loading: false, error: action.payload };
		default:
			return state;
	}
};
